export const ENDPOINTS = {
  AUTH: {
    CAPABILITIES: '/capabilities/v1/clients/:clientId/seats/:seatId',
    LOGIN: '/download/v2/auth/login',
    LOGOUT: '/download/v2/auth/logout',
    MFA: '/download/v2/auth/login/callback/mfa',
  },
  CONTEXT: '/download/v2/auth/context',
  DOWNLOAD: '/download/v1/files/:clientId/:fileName?noredirect=true',
}
